module.exports = "<ul class=\"c-over-image-stats-grid\">\n\t<li *ngFor=\"let item of data;\" class=\"c-over-image-stats-grid__item\">\n\t\t<span class=\"c-over-image-stats-grid__item__value\">{{item.value}}</span>\n\t\t{{item.label}}\n\t</li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/over-image-stats/over-image-stats.component.html
// module id = ./src/app/modules/common-module/components/over-image-stats/over-image-stats.component.html
// module chunks = 9